/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const GetCaptureGuideData = data => {
  return new Promise(function request(resolve, reject) {
    maverickPortalhttp
      .makeRequest(
        `${maverickPortalApiEndPoint.getCaptureGuide.url}/${data.user_ID}/${data.project_ID}/${data.projectRespondent_ID}/${data.videoTask_ID}`,
        maverickPortalApiEndPoint.getCaptureGuide.methodType
      )
      .then(response => {
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        // if(response.data?.Response?.captureGuide){
        const res = response.data;
        resolve({ res });
        // }else{
        // const err = response.data;
        // reject({err});
        // }
      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { GetCaptureGuideData };
